angular.module('impactx.search').controller('ProductItemPriceCtrl', [
    'TranslationService',
    'dataGen',
    '$securityManager',
    '$route',
    '$mdDialog',
    'ProductEuelService',
    ProductItemPriceController
]);

function ProductItemPriceController(TranslationService, dataGen, $securityManager, $route, $mdDialog, ProductEuelService) {
    var self = this;
    self.perLabel = TranslationService.get("per");
    self.coAmountFillLabel = TranslationService.get("coAmountFill");
    self.andLabel = TranslationService.get("and");
    self.orderStopNotificationLabel = TranslationService.get("orderStopNotification");
    self.inStock = TranslationService.get("inStock");
    self.soldOutLabel = TranslationService.get("soldOut")
    self.productDataSheetLabel = TranslationService.get("productDataSheet");
    self.productEuelService = ProductEuelService;

    self.$onInit = function () {
        var hasAdditional = impactX.isDefined(self, 'product.basketLink.additionalPrices.length');
        if (!hasAdditional) {
            self.price = impactX.isDefined(self, 'product.basketLink.price');
            self.secondPrice = impactX.isDefined(self, 'product.basketLink.secondPrice');
            self.fictionalPriceLabel = TranslationService.get("fictionalPrice");
        }
        else {
            self.price = impactX.isDefined(self, 'product.basketLink.mainAdditionalPrice');
        }
        self.contentUnitText = getContentUnitText(self.price);
        self.message = impactX.isDefined(self, 'product.basketLink.message');
        self.isCompilationProduct = impactX.isDefined(self, 'product.basketLink.isCompilationProduct');
        self.ostNotificationSet = impactX.isDefined(self, 'product.basketLink.ostNotificationSet');
        self.hasOrderStop = impactX.isDefined(self, 'product.basketLink.hasOrderStop');
        self.canSetOstNotification = impactX.isDefined(self, 'product.basketLink.canSetOstNotification');
        self.showChangeOstNotification = self.hasOrderStop && $securityManager.isProcessAllowed("OrderStopNotification")
            && (self.canSetOstNotification !== false || self.ostNotificationSet);
        self.soldOut = impactX.isDefined(self, 'product.basketLink.soldOut');
    };

    // ToDo: we should do this at the backend
    function getContentUnitText(price) {
        var result;
        // if we don't have a price, we dont need a content unit
        if (self.price.basePrice) {
            result = self.perLabel + ' ';
            if (price.priceAmountFormatted && price.priceAmountFormatted.length > 0) {
                result += price.priceAmountFormatted + ' '
                    + price.orderUnitPlural
            }
            else if (price.priceAmount) {
                result += price.priceAmount + ' '
                    + price.orderUnitPlural
            }
            else {
                result += price.orderUnit;
            }

            if (price.showContentUnit) {
                result += self.coAmountFillLabel + ' '
                    + price.coUnitPerOrderUnit + ' '
                    + price.contentUnit;
            }
        }
        return result;
    }

    self.changeOstNotification = function () {
        dataGen.postAsForm({}, {proId: self.product.id, setNotification: self.ostNotificationSet}, "/catalog/orderstop/notification/change").then(
            angular.noop(),
            function () {
                $route.reload();
            });
    };

    self.openTimedBaseProductStockDialog = function (event) {
        $mdDialog.show({
            controller: "TimedBaseProductStockDialogCtrl",
            controllerAs: "timedBaseProductStockDialogCtrl",
            templateUrl: "modules/search/templates/timedbaseproduct.dialog.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                product: self.product
            }
        })
    };
}